import { Injectable, InjectionToken, inject } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

export const GQL_TOKEN = new InjectionToken<GqlServiceV2[]>('GqlService');

@Injectable({
    providedIn: 'root',
})
export class GlobalGqlService extends GqlServiceV2 {
    private readonly services = inject(GQL_TOKEN);

    constructor() {
        super();
        this.services.forEach((it) => this.injectService(it));
    }

    /**
     * Sets methods (gql calls) from dependency into singular global object
     * @param service
     * @protected
     */
    protected injectService(service: GqlServiceV2): void {
        const ignore = ['constructor', 'query', 'mutate', 'apollo', 'regex'];
        const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(service));
        methods.forEach((method) => {
            if (!ignore.includes(method)) {
                if (method in this) {
                    throw new Error(`Non unique gql method [${method}] injection`);
                }

                Object.defineProperty(
                    Object.getPrototypeOf(this),
                    method,
                    {
                        value: (service as any)[method].bind(this),
                        writable: true,
                        configurable: true,
                    },
                );
            }
        });
    }

}
